import * as React from "react";
import { connect, useSelector } from "react-redux";
import { Slide } from "@progress/kendo-react-animation";
import { Notification, NotificationGroup } from "@progress/kendo-react-notification";


/**
 * To get kendo popup notification window
 * @param {*} props
 * @returns {JSX} popup window.
 */
const Notify = (props) => {
  const { message, icon, onClicknotif, showAlert } = props;
  const [show, setShow] = React.useState(false);
  const [notiMessage, setNotiMessage] = React.useState(null);
  const [notiIcon, setNotiIcon] = React.useState(null);
  const { isAuthenticated } = useSelector((state) => state.auth);

  React.useEffect(() => {
    setShow(showAlert);
    if (showAlert) {
      setNotiMessage(message);
      setNotiIcon(icon);
    }
  }, [showAlert]);

  const handleClose = () => {
    setShow(false);
  };

  return (
    <React.Fragment>
      <div id='notify-notification-box'>
        <NotificationGroup
          className='notification-group notification-d1  align-items-start flex-wrap-reverse position-fixed '
          style={{ top: isAuthenticated ? "15px" : "15px" }}>
          <Slide direction={show ? "down" : "up"}>
            {show && (
              <Notification className='kendo-notifications' type={{ style: notiIcon, icon: true }} closable={true} onClose={handleClose}>
                <span id='notify-notification-message' onClick={() => onClicknotif()}>
                  {notiMessage}
                </span>
              </Notification>
            )}
          </Slide>
        </NotificationGroup>
      </div>
    </React.Fragment>
  );
};
/**
 * merges ReduxStore with props
 * @param {*} state
 * @returns {state as props}
 */
function mapStateToProps(state) {
  return {
    loading: state.loader.loading,
  };
}
export default connect(mapStateToProps)(Notify);